export const PROTOCOL_MODULE = Symbol('PROTOCOL_MODULE')

export const PROTOCOL_API_KEY = Symbol('PROTOCOL_API_KEY')

export const PROTOCOL_SERVICE_KEY = Symbol('PROTOCOL_SERVICE_KEY')
